/* eslint-disable angular/controller-name */

angular.
module("digiexam").
controller("MonitorExamProgressGuideController", function MonitorExamProgressGuideController(
	dxLocalize,
	dxSession
) {
	"use strict";

	var self = this;

	self.dxLocalize = dxLocalize;
	self.user = dxSession.getUser();

	self.numberOfSlides = 1;
	self.currentSlide = 1;
	self.paginationSlides = [];
	self.user.load();

	self.updateGettingNewFeatureGuideDisabled = function updateGettingNewFeatureGuideDisabled() {
		self.user.update();
	};
});
